import React from 'react'
import { useParams } from 'react-router-dom'
import PatientAddDMSNoteComponent from './PatientAddDMSNoteComponent'
export default function PatientAddDMSNote() {
    const { id, event } = useParams()
    return (
        <PatientAddDMSNoteComponent id={id} event={event} />
    )
}
